const $ = require('jquery');
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import {quickFileUploader} from "../../components/QuickFileUploader/QuickFileUploader";
import collectDataAttributesFor from "../../utilities/collectDataAttributesFor";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

const targetSelector = "#location-bulk-upload-section";
run(targetSelector, (outerEl)=>{
  const data = outerEl.data();
  const lang = collectDataAttributesFor(outerEl.get(0), {prefix: "lang", camelize: false});
  const csvFileUpload = outerEl.find(".logo-uploader");
  const bulkLocationTable = outerEl.find("#bulk-location");
  //const errorMsgLocation = outerEl.find("#error-msg-bulk-location");
  const uploadButton = outerEl.find("#upload-btn");
  const uploadProgressBar = outerEl.find("#uploadProgressBar");
  const sucessMsgBulkLocation = outerEl.find("#sucess-msg-bulk-location");
  const invalidErrorLocation = outerEl.find("#invalid-error-msg-bulk-location");
  const bulkLocationSubmit = outerEl.find("#bulk-location-submit");
  const preUpload = outerEl.find(".pre-upload");
  const rowUploaded = outerEl.find("#rowuploaded");
  const uploadFileUrl = data.uploadCsvUrl;
  const progressBarEl = data.uploadProgressId;
  const csvJSONInput = outerEl.find(`#${data.namespace}csvJSON`);
  const locationSubmitValidationError = outerEl.find(`#${data.namespace}bulk-location-validat-error-msg`);
  const successModel = $("#bulk-location-success-modal"); // have to use id as modals are pushed at the end of body (implemented in theme )and will not be about to find by outerEl
  const bulkUploadLocationForm = outerEl.find("#bulk-upload-location-form");
  const bulklocationLookupURL = outerEl.data("bulk-location-lookup-url");
  bulkLocationTable.hide();

  const quickFile = quickFileUploader(csvFileUpload,{
    afterReadFile: function(e,result){
      uploadButton.removeClass("disabled");
    }
  });

  const locationsUploadSuccessModal = new SubmitModalFlow({
    confirmModalTitle: 'Are you sure you want to Upload this file ?',
    // confirmModalSubtitle: "Optional Subtitle",
    confirmModalBody: '<div class="q-pad-all-xl">Once the file is uploaded, the location(s) will be saved and made active. They can be edited using the locations screen</div>',
    confirmModalBtnText: 'Save',
    onConfirmClick: function(){
      bulkUploadLocationForm.submit();
      locationsUploadSuccessModal.showLoadingModal();
    }
  });
  locationsUploadSuccessModal.init();

  uploadButton.on('click',function(){
    let formData = new FormData();
    
    formData.append("fileName",quickFile.getFile());
    preUpload.hide();
    window[progressBarEl].startProgress();
    $.ajax({
      url: uploadFileUrl,
      type: "POST",
      data: formData,
      enctype:"multipart/form-data",
      processData:false,
      contentType:false,
      dataType: "json",
      success: function(csvData){
        delete data.errorlist;
        setInterval(function(){ 
            bulkLocationTable.show();
            uploadProgressBar.hide(); 
            sucessMsgBulkLocation.show();
            bulkLocationSubmit.removeAttr("disabled");
            bulkLocationSubmit.removeClass("disabled"); 
            outerEl.find(".bulk-location").show();
            invalidErrorLocation.hide();
            locationSubmitValidationError.hide();
          }, 3000);
        
        buildDataTable(csvData);
            
        csvJSONInput.val(JSON.stringify(csvData));
      },
      error: function(){
        uploadProgressBar.hide();
        invalidErrorLocation.show();
      }
    });

  });

  

  if(isPresent(data.csvjson)){
    preUpload.hide();
    sucessMsgBulkLocation.hide();
    bulkLocationTable.show();
    buildDataTable(data.csvjson);
    
    if(isPresent(data.isFormSubmit)){
      if(data.errorlist && data.errorlist.length > 0){
        locationSubmitValidationError.show();
      }else{
        locationSubmitValidationError.hide();
        locationsUploadSuccessModal.showSuccessModal();
        location.href = `${bulklocationLookupURL}`;
        setTimeout(function() {
        locationsUploadSuccessModal.hideAllModals();
      }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  }


  bulkLocationSubmit.on('click', function(){
    locationsUploadSuccessModal.showConfirmModal();
  });

 /* bindHardSubmit({
    form: bulkUploadLocationForm,
    links: bulkLocationSubmit
  });*/

  function buildDataTable(csvjson){

    bulkLocationTable.dataTable({
          data: csvjson,
          scrollX: true,
          "bPaginate": true,
          "bDestroy" : true,
          "pageLength": 100,
          "columns": [
            { data: 'locationId' , title : lang['bulk-location-table-header-external-location-id'] },
            { data: 'active', title :  lang['bulk-location-table-header-active'] },
            { data: 'locationName', title :  lang['bulk-location-table-header-location-name']},
            { data: 'contactName' , title :  lang['bulk-location-table-header-contact-name']},
            { data: 'contactCountryCode', title :  lang['bulk-location-table-header-country-code'] },
            { data: 'contactPhone', title :  lang['bulk-location-table-header-phone']},
            { data: 'email' , title : lang['bulk-location-table-header-email'] },
            { data: 'address1', title : lang['bulk-location-table-header-address1'] },
            { data: 'address2' , title :  lang['bulk-location-table-header-address2']},
            { data: 'city', title :  lang['bulk-location-table-header-city'] },
            { data: 'state' , title :  lang['bulk-location-table-header-state']},
            { data: 'zip' , title : lang['bulk-location-table-header-zip'] },
            { data: 'country' , title :  lang['bulk-location-table-header-country']},
            { data: 'inboundClassification', title :  lang['bulk-location-table-header-inbound-classification']},
            { data: 'fedexAccountNumber', title :  lang['bulk-location-table-header-fedex-account-number']},
            { data: 'hubId', title :  lang['bulk-location-table-header-hub-id']},
            { data: 'organizationName', title :  lang['bulk-location-table-header-organization-name']},
            { data: 'facilityType', title :  lang['bulk-location-table-header-facility-type']},
            { data: 'raRequired', title :  lang['bulk-location-table-header-ra-required']},
            { data: 'standingRaNumber', title :  lang['bulk-location-table-header-standing-ra-number']}
          ] ,
          fnCreatedRow: function(nRow, aData, iDisplayIndex) {
            
            if(data.errorlist){
              if(data.errorlist.indexOf(iDisplayIndex) >=0) {
                nRow.className="alert-danger";
              }
            }else{
              rowUploaded.html(iDisplayIndex+1);  
            }
            
          } 
        });
  }

});


// WEBPACK FOOTER //
// ./src/pages/locations/locations.js